/**
 * @voltxampere/ui — 9V alkaline battery (Sprint 51-1 polish)
 *
 * Standard 9V transistor battery (NEDA 1604, MN1604) — generic
 * alkaline cell stack. Counterpart to `battery-9v-clip` (Sprint 49-7
 * snap connector). Used in guitar effects, smoke detectors, multi-
 * meters. Internal resistance ~2Ω at fresh full charge.
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const battery9vAlkaline = {
    id: "battery-9v-alkaline",
    nameTr: "9V Alkalin Pil (NEDA 1604)",
    nameEn: "9V Alkaline Battery (NEDA 1604)",
    shortcut: "B",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "BAT",
    defaultValue: "9V",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 9,
        chemistry: "alkaline",
        standard: "NEDA 1604 / IEC 6LR61",
        internalResistanceOhm: 2,
        typicalCapacityMah: 565,
        nominalLifeHours: 50,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=battery-9v-alkaline.js.map